import { Reveal, Eyebrow } from "./Reveal";
import Magnetic from "./Magnetic";
import { scrollToId } from "@/lib/scroll";

const Distributor = () => (
  <section id="distributor" data-testid="distributor-section" className="relative bg-[#FAF7F5] py-24 sm:py-36 overflow-hidden">
    <div className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full bg-[#E893AE]/15 blur-[130px] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <Eyebrow>Official distributor</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-serif font-light text-[#1C1417] tracking-tight leading-[1.04] mt-6">
          <span className="block text-[9vw] sm:text-6xl lg:text-7xl">SKINFILL BACIO®</span>
          <span className="block text-[7vw] sm:text-4xl lg:text-5xl mt-3">
            AUSTRALIA <span className="italic text-[#D4AF37]">+</span>{" "}
            <span className="italic text-[#A31D4F]">NEW ZEALAND</span>
          </span>
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-8 text-base sm:text-lg font-light text-[#6E6266]">
          Exclusively distributed by{" "}
          <span className="font-mono text-sm sm:text-base tracking-[0.25em] text-[#1C1417] uppercase">Dermalis</span>
        </p>
      </Reveal>

      <Reveal delay={0.22}>
        <div className="mt-12 flex flex-col items-center gap-6">
          <div className="inline-flex items-center rounded-full glass-panel px-6 sm:px-10 py-5">
            <a
              data-testid="distributor-email-link"
              href="mailto:info@dermalis.com.au"
              className="font-mono text-xs sm:text-sm tracking-[0.15em] text-[#A31D4F] hover:text-[#86143E] transition-colors"
            >
              info@dermalis.com.au
            </a>
          </div>
          <Magnetic>
            <button
              data-testid="distributor-cta-contact"
              onClick={() => scrollToId("#contact")}
              className="btn-lux btn-lux-magenta"
            >
              <span>Contact Dermalis</span>
            </button>
          </Magnetic>
        </div>
      </Reveal>

      <Reveal delay={0.28}>
        <div className="mt-14 grid grid-cols-2 gap-4 max-w-2xl mx-auto">
          <div data-testid="distributor-card-australia" className="rounded-3xl border border-[#EADECE] bg-white/70 p-8">
            <p className="font-serif italic text-2xl sm:text-3xl text-[#1C1417]">Australia</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E6266] mt-3">Official market</p>
          </div>
          <div data-testid="distributor-card-new-zealand" className="rounded-3xl border border-[#EADECE] bg-white/70 p-8">
            <p className="font-serif italic text-2xl sm:text-3xl text-[#1C1417]">New Zealand</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E6266] mt-3">Official market</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Distributor;
